























































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY as PARENT_STORE_KEY } from "../AgentDetails/_store";
import { STORE_KEY, store } from "./_store";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(PARENT_STORE_KEY, ["document"]),
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "form",
      "formDirty",
      "meta"
    ]),
    ...mapGetters(STORE_KEY, ["fields"])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      code: {},
      entity_id: { required },
      inn: {},
      code_1s: {},
      market_type: { required },
      business_scope_id: { required },
      city_id: { required },
      competitor_trademark: { required },
      contacts: {},
      credit: {},
      delivery_warehouse_id: { required },
      destination_warehouse_id: {},
      manager_id: { required },
      month_weight_plan: {},
      payment_deferment_period_id: { required },
      payment_type_id: { required },
      preferred_product_container_id: {},
      preferred_product_container_2_id: {},
      preferred_product_container_3_id: {},
      primary_contact_type: {},
      secondary_manager_id: {},
      source: { required },
      color: {},
      lk_allow_calc_containers: {},
      lk_allow_calc_weight: {},
      no_take_in_plan: {},
      deal_comment: {},
      custom_plan: {},
      special_orders: {}
    };

    return {
      form: rules
    };
  }
})
export default class AgentForm extends Vue {
  document!: any;
  form!: any;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log("mounted", this.document, this.document.id);
    if (this.document.id) {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.document.id
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`);
    }
    this.$v.form.$touch();
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
  }

  saveFormData() {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(`${STORE_KEY}/saveForm`, {
          id: this.document.id
        })
        .then(result => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          this.$emit("on-need-data-reload", result.document.id);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
